var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_vm._t("default"),_c('app-notification',{attrs:{"data":_vm.feedback}}),_c('app-loader',{attrs:{"loading":_vm.loading}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }